import { render, staticRenderFns } from "./SubmitDecisionCard.vue?vue&type=template&id=8dfa988e&scoped=true&"
import script from "./SubmitDecisionCard.vue?vue&type=script&lang=js&"
export * from "./SubmitDecisionCard.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDecisionCard.vue?vue&type=style&index=0&id=8dfa988e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfa988e",
  null
  
)

export default component.exports